import {
    DEALERCHECKLIST_SUCCESS,
    DEALERCHECKLIST_FAILED,
    RESET_DEALERCHECKLIST,
    LOADING_DEALERCHECKLIST,
    NETWORK_ERROR_DEALERCHECKLIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERCHECKLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERCHECKLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERCHECKLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERCHECKLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERCHECKLIST:
            return (state = initialState);
        default:
            return state;
    }
};